import { render, staticRenderFns } from "./news_content.vue?vue&type=template&id=4b77230a&scoped=true&"
import script from "./news_content.vue?vue&type=script&lang=js&"
export * from "./news_content.vue?vue&type=script&lang=js&"
import style0 from "./news_content.vue?vue&type=style&index=0&id=4b77230a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b77230a",
  null
  
)

export default component.exports